







import {Component, Vue} from "vue-property-decorator";
import RoleForm from "../Form/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "RoleCreate",
    components: {RoleForm}
})
export default class extends mixins(CommonMixin)  {
}
